import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { ConfirmationGlobalService } from './../shared/services/confirmation-global.service';
import { ConfirmationFormService } from './../confirmation-form.service';
import { ApiConstant } from './../../../utils/api-constant/api-constant.service';

import { NgxImageCompressService } from 'ngx-image-compress';
export class ConfirmationPinPictureService {
public dataStore: Observable<any>;
private update: BehaviorSubject<any>;
private store;
/**
 * @param {?} parentService
 * @param {?} imageCompress
 * @param {?} confirmationService
 * @param {?} http
 * @param {?} api
 */
constructor(
public parentService: ConfirmationFormService,
private imageCompress: NgxImageCompressService,
private confirmationService: ConfirmationGlobalService,
private http: HttpClient,
private api: ApiConstant,
  ) {
    // main store
    this.store = {
      progress: 1,
      isValid: false,
      isError: null,
      isBusy: false,
      image: null,
      profile: null,
      loan: null,
    };

    // main function for dispatcher
    this.update = <BehaviorSubject<any>>new BehaviorSubject({});
    this.dataStore = this.update.asObservable();
    this.update.next(this.store);
  }
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ data = ( /** @type {?} */((<any>Object))).assign(this.store, obj);
    this.update.next(data);
  }
/**
 * @param {?} file
 * @return {?}
 */
public upload(file: File) {
    const /** @type {?} */ headers = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.store.profile,
      }),
    };

    this.setStore({
      isBusy: true,
    });

    const /** @type {?} */ formData: FormData = new FormData();
    formData.append('loanId', this.store.loan.id);
    formData.append('fileData', file, 'KTP Picture');

    this.http
      .post(`${this.api.apiURL}/loan/confirm/ktp`, formData, headers)
      .subscribe(
        res => {
          this.setStore({
            isBusy: false,
            progress: 100,
          });
        },
        (err: HttpErrorResponse) => {
          if (err.status === 500) {
            this.setStore({
              isBusy: false,
              progress: 99,
              isValid: false,
              isError: 'server',
            });
          } else {
            this.setStore({
              isBusy: false,
              progress: 99,
              isValid: false,
              isError: 'connection',
            });
          }
        },
      );
  }
/**
 * @return {?}
 */
public compressFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      const /** @type {?} */ file = this.confirmationService.transformImage(
        image,
        'PIN Picture',
      );

      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.setStore({
          isValid: false,
          progress: 0,
          preview: null,
          isError: 'file',
        });
      } else if (file.size > 4000000) {
        this.setStore({
          isValid: false,
          progress: 0,
          isError: 'file',
        });
      } else {
        this.setStore({
          isValid: true,
          progress: 0,
          isError: null,
        });

        this.imageCompress
          .compressFile(image, orientation, 90, 90)
          .then(result => {
            const /** @type {?} */ compressedFile = this.confirmationService.transformImage(
              result,
              'PIN Picture',
            );

            this.setStore({
              image: compressedFile,
              preview: image,
            });

            this.upload(compressedFile);
          });
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationFormService, },
{type: NgxImageCompressService, },
{type: ConfirmationGlobalService, },
{type: HttpClient, },
{type: ApiConstant, },
];
}

function ConfirmationPinPictureService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationPinPictureService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationPinPictureService.ctorParameters;
/** @type {?} */
ConfirmationPinPictureService.prototype.dataStore;
/** @type {?} */
ConfirmationPinPictureService.prototype.update;
/** @type {?} */
ConfirmationPinPictureService.prototype.store;
/** @type {?} */
ConfirmationPinPictureService.prototype.parentService;
/** @type {?} */
ConfirmationPinPictureService.prototype.imageCompress;
/** @type {?} */
ConfirmationPinPictureService.prototype.confirmationService;
/** @type {?} */
ConfirmationPinPictureService.prototype.http;
/** @type {?} */
ConfirmationPinPictureService.prototype.api;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
